<template>
  <FadeInTransition>
    <div
      class="t-0 absolute h-80 max-h-[55vh] w-full px-5 pb-8 text-center md:inset-0 md:my-auto md:flex md:h-full md:max-h-0 md:flex-col md:items-center md:justify-center md:pb-28 lg:max-w-[45rem] lg:px-20"
      data-testid="rx-configurator-error"
    >
      <h1 class="mb-4 text-2xl font-medium md:mb-8 md:text-4xl">
        {{ $t('rxConfigurator.error.out_of_stock_title') }}
      </h1>
      <p class="mb-4 text-base leading-[28px] md:mb-8 md:text-[21px]">
        {{ $t('rxConfigurator.error.out_of_stock_text') }}
      </p>
      <Button
        type="primary"
        class="rounded-lg px-6 py-3 text-lg"
        no-padding
        @click="backToProduct"
        >{{ $t('rxConfigurator.error.back') }}</Button
      >
    </div>
  </FadeInTransition>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'
import useUiState from '~/composables/ui/useUiState'
import { useRxConfiguratorState } from '~/composables/useRxConfiguratorState'

const props = defineProps({
  frameProduct: {
    type: Object as PropType<Product>,
    required: true,
  },
})

const localePath = useFimLocalePath()
const { closeRxConfiguratorOverlay } = useUiState()
const { getProductDetailRoute } = useRouteHelpers()
const { setErrorState } = await useRxConfiguratorState()
const router = useRouter()

const backToProduct = async () => {
  closeRxConfiguratorOverlay()
  setErrorState(false)
  await nextTick()
  router.push(localePath(getProductDetailRoute(props.frameProduct)))
}
</script>
